import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge from '../../../components/Badge';
import { humanizeExpirationDate } from '../../../queries/ats/me/products/utils';
import type { VodSource } from '../../../queries/ats/titles/types/sources';

export function VodBadge({ source }: { source: VodSource }) {
  const { t } = useTranslation();

  switch (source.product.status) {
    case 'purchased':
      return <Badge text={t('common:purchased')} type="success" />;
    case 'rented':
      return <Badge text={humanizeExpirationDate(source.product.expiresAt)} type="dark" />;
    case 'pending':
      return null;
  }
}
